var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('CidadaoEndereco',{attrs:{"termos-invalidos":_vm.form.cidadao.termosInvalidos,"data-atual":_vm.form.cidadao.dataAtual,"form":_vm.form.cidadao.endereco,"isPermissaoEndereco":_vm.form.isPermissaoEndereco,"model":_vm.model.cidadao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }